import React from "react";
import { Image } from "react-bootstrap";
import {
  powerThePollsLogo,
} from "../lib/images";
import {
  Header,
  Footer,
  EmailSignup,
  LineSplit,
  QuizLPPowerthePolls,
  AlertSignup,
  AddressCollectionLower,
  Calendar,
} from "../components";

import "../components/QuizLandingPage/QuizLandingPage.style.scss";
import config from "../lib/config";
import { Helmet } from "react-helmet-async";
/*Quiz Landing Page - Power the Polls */
import { Trans, useTranslation } from "react-i18next";

function QuizLanding09() {
  let imageUrl = [window.location.protocol, "//", window.location.host, config.seo.default.image].join("");
  let ogUrl = window.location.href;
  const { t } = useTranslation();
  return (
    <div className="ctn-quiz-landing04">
      <Helmet>
        <title>{t("seo_powerthepolls_title")}</title>
        <meta name="description" content={t("seo_powerthepolls_page_description")} />
        <meta name="image" content={imageUrl} />
        <meta name="twitter:title" content={t("seo_powerthepolls_tw_title")} />
        <meta name="twitter:description" content={t("seo_powerthepolls_tw_description")} />
        <meta name="twitter:image" content={imageUrl} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta itemProp="name" content={t("seo_powerthepolls_title")} />
        <meta itemProp="description" content={t("seo_powerthepolls_page_description")} />
        <meta itemProp="image" content={imageUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={ogUrl} />
        <meta property="og:title" content={t("seo_powerthepolls_page_title")} />
        <meta property="og:description" content={t("seo_powerthepolls_page_description")} />
        <meta property="og:image" content={imageUrl} />
        <script
          async
          type="module"
          src="https://interfaces.zapier.com/assets/web-components/zapier-interfaces/zapier-interfaces.esm.js"
        ></script>
      </Helmet>
      <div className="home-top-email">
        <AlertSignup />
      </div>
      <Header />
      <div id="page-wrap">
        <zapier-interfaces-chatbot-embed
          is-popup="true"
          chatbot-id="clw6ma3cx001211koyb07xyml"
          height="600px"
          width="400px"
        ></zapier-interfaces-chatbot-embed>
        <LineSplit />
        <div className="quiz-landing-header">
          <div className="quiz-landing-title">
            <hgroup>
              <h1>
                <Trans i18nKey="help_staff"></Trans>
              </h1>
              <div className="ptp-partnership-wrapper">
                <p className="in_partnership">
                  <Trans i18nKey="in_partnership"></Trans>
                </p>
                <div className="ptp-logo-wrapper">
                  <Image
                    src={powerThePollsLogo}
                    alt="Power The Polls Logo"
                    className="ptp-logo-image"
                  />
                </div>
              </div>

            </hgroup>
          </div>
        </div>
        <LineSplit noMarginBottom="true" />
        <QuizLPPowerthePolls />
        <LineSplit />
        <Calendar isPeach={true} />
        <LineSplit />
        <EmailSignup isMidPage="true" />
        <LineSplit />
        <Footer flat={true} />
      </div>
    </div>
  );
}

export default QuizLanding09;
